/**
 * SA-1009 (design note D2): the files each message could not load, by the
 * message's provider id. Only a body message carries `provider_message_id`;
 * an attachment row names its body under its own key, and a note none, so
 * neither is marked. Pure.
 */
import type { InboxMessage, InboxMissingFile } from '@/types/inbox'

export function indexMissingFiles(files?: readonly InboxMissingFile[]): Map<string, InboxMissingFile[]> {
  const index = new Map<string, InboxMissingFile[]>()
  for (const file of files ?? []) {
    const list = index.get(file.providerMessageId)
    if (list) list.push(file)
    else index.set(file.providerMessageId, [file])
  }
  return index
}

export function missingFor(message: InboxMessage, index: Map<string, InboxMissingFile[]>): InboxMissingFile[] {
  const id = message.channelMetadata?.provider_message_id
  return typeof id === 'string' && id ? index.get(id) ?? [] : []
}
